import type { FC } from 'react';

import styles from './AccountSidebarSeparator.module.scss';

const AccountSidebarSeparator: FC = () => <div className={styles.accountSidebarSeparator} />;

export default AccountSidebarSeparator;
